import { createFileRoute } from '@tanstack/react-router'

import { AchTrendsScreen } from './-components/ach-trends-screen.tsx'

export const Route = createFileRoute('/ach/trends')({
  component: AchTrendsScreen
})
